module.exports = __webpack_public_path__ + "static/covid-19-2-fa933a33ef9e5d2ee87d4882b1850fd1.jpg";